import React, { useCallback, useMemo } from 'react';

const withValueTransforms = C => ({ name, onChange: onChangeProp, value: valueProp, valueFieldName, isMulti, options, ...rest }) => {
  const onChange = useCallback((newVal) => {
    if (typeof onChangeProp === 'function') {
      if (Array.isArray(newVal) && isMulti && valueFieldName) {
        newVal = newVal.map(v => v[valueFieldName]);
      }

      if (newVal && !isMulti && valueFieldName) {
        newVal = newVal[valueFieldName];
      }

      onChangeProp({ target: { name, value: newVal } });
    }
  }, [onChangeProp, name, valueFieldName, isMulti]);


  const value = useMemo(() => {
    const convert = (val) => {
      if (typeof val !== 'string') console.warn('valueFieldName value must be a string!');
      if (Array.isArray(options) && options.every(o => Array.isArray(o.options))) {
        const flatOptions = options.flatMap(o => o.options);
        return (flatOptions.find(o => o[valueFieldName] === val)) || { [valueFieldName]: val, label: val };
      }
      return (options && options.find(o => o[valueFieldName] === val)) || { [valueFieldName]: val, label: val };
    };

    if (!valueFieldName || !valueProp) return valueProp;
    if (isMulti && Array.isArray(valueProp)) {
      return valueProp.map(convert);
    } else {
      return convert(valueProp);
    }
  }, [valueFieldName, valueProp, isMulti, options]);

  const getOptionValue = useCallback(o => {
    if (valueFieldName) return o[valueFieldName];
    // calculating default key
    let key = o.id || o.key;
    if (o.child && o.child.id) key = `${key}${o.child.id}`;
    return key;
  }, [valueFieldName]);

  return (
    <C
      onChange={onChange}
      value={value}
      options={options}
      getOptionValue={getOptionValue}
      isMulti={isMulti}
      name={name}
      {...rest}
    />
  );
};

export default withValueTransforms;
